import React from 'react';

/**
 * Glyphs the redesign primitives need that the shared icon family does not
 * yet carry. Same stroke conventions as components/icons.tsx so they read as
 * one family; extend icons.tsx when a screen migration touches it.
 */
interface IconProps {
  size?: number;
  className?: string;
}

function svgProps(size: number, className?: string) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
    'aria-hidden': true,
    focusable: false,
  };
}

export const MenuIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const PlayIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)} fill="currentColor" stroke="none">
    <path d="M8 5.5v13l10-6.5z" />
  </svg>
);

export const PauseIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)} fill="currentColor" stroke="none">
    <rect x="7" y="5" width="3.5" height="14" rx="1" />
    <rect x="13.5" y="5" width="3.5" height="14" rx="1" />
  </svg>
);

export const ChevronDownIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="m6 10 6 6 6-6" />
  </svg>
);

export const ChevronUpIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="m6 14 6-6 6 6" />
  </svg>
);

export const CheckIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="m5 12.5 4.5 4.5L19 7.5" />
  </svg>
);

export const AlertIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5v5.5" />
    <path d="M12 16.5h.01" />
  </svg>
);

export const HomeIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M4 11.5 12 5l8 6.5" />
    <path d="M6.5 10v9.5h11V10" />
  </svg>
);

export const MoreIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)} fill="currentColor" stroke="none">
    <circle cx="6" cy="12" r="1.6" />
    <circle cx="12" cy="12" r="1.6" />
    <circle cx="18" cy="12" r="1.6" />
  </svg>
);
